module.exports = __webpack_public_path__ + "52d18ecbc3c92ce3e0f3a15cf93dd1b4.png";